<script lang="ts">
  import {
    GridColumn,
    GridWrap,
    GridColumnModifier,
    GridWrapModifier,
  } from '$lib/components/grid';
  import {resolveStaticAssetPath} from '$lib/utils/components';
</script>

<div class="area-header">
  <GridWrap modifiers={[GridWrapModifier.Middle]}>
    <GridColumn modifiers={[GridColumnModifier.Auto]}>
      <slot />
    </GridColumn>

    <GridColumn modifiers={[GridColumnModifier.ShrinkWrap]}>
      <a href="/">
        <img
          src={resolveStaticAssetPath('logos/cillar-logo.svg')}
          alt="Cillar logo"
        />
      </a>
    </GridColumn>
  </GridWrap>
</div>
